export default __webpack_public_path__ + "static/media/session-complete.fbef77a6.svg";